import { z } from 'zod'

/**
 * Types and schemas for auth-related Firebase Functions
 */

export const RequestPasswordResetSchema = z.object({
  email: z.email('Invalid email address'),
})

export type RequestPasswordResetRequest = z.infer<
  typeof RequestPasswordResetSchema
>

export interface RequestPasswordResetResponse {
  success: boolean
  message: string
}

export const ResetPasswordSchema = z
  .object({
    password: z.string().min(6, 'Password must be at least 6 characters'),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  })

export type ResetPasswordInput = z.infer<typeof ResetPasswordSchema>
